import { useMutation } from '@tanstack/react-query'

import { updateControllerConfigLatestVersion } from '@/features/controller/configuration/endpoints/controllerConfiguration'
import type { ControllerConfigTypeId, ControllerConfigVersionUpdate } from '@/features/controller/configuration/types'

export function useUpdateControllerConfigLatestVersionMutation(
  controllerId: string,
  configTypeId: ControllerConfigTypeId,
) {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (payload: ControllerConfigVersionUpdate) =>
      updateControllerConfigLatestVersion(controllerId, configTypeId, payload),
  })

  return {
    updateControllerConfigLatestVersion: mutateAsync,
    ...mutationResult,
  }
}
